import { render, staticRenderFns } from "./EditAutoDelivery.vue?vue&type=template&id=afadd2b0&scoped=true&lang=pug&"
import script from "./EditAutoDelivery.vue?vue&type=script&lang=js&"
export * from "./EditAutoDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afadd2b0",
  null
  
)

export default component.exports